import "../../assets/fa-icons/css/fontawesome.css";
import "../../assets/fa-icons/css/sharp-regular.css";
import { SectionHeader } from "../components/section-header.tsx";
import { FontStyles } from "../utils/font-styles.ts";
import { useId } from "react";
import { CharteredLogo } from "../solicitors/chartered-logo.tsx";
import { ButtonLink } from "../components/buttons/button-link.tsx";
import { FirmCard } from "../components/firm-card.tsx";
import { AgentLogoImage } from "../components/agent-logo-image.tsx";
import { usePropertyDetailsContext } from "./contexts/property-details-context.tsx";
import { BookingButton } from "./components/booking-button.tsx";
import { TOP_BAR_STICKY_OFFSET_PX } from "./top-bar.tsx";
import { TrackEvent } from "../utils/analytics.ts";

export const MarketedBy = () => {
  const { agentLogoUrl, agentName, chartered, hrLink, scheduleLink, agentPageUrl, viewingDescription } =
    usePropertyDetailsContext();
  const sectionId = useId();
  return (
    <section
      // -mt-3.5 cancels the inner top padding in normal flow so the gap under the ad stays the column gap.
      // Sticky positioning uses the border edge, so the stuck position is unaffected.
      className="sticky overflow-y-auto w-full -mt-3.5"
      style={{ top: TOP_BAR_STICKY_OFFSET_PX, maxHeight: `calc(100vh - ${String(TOP_BAR_STICKY_OFFSET_PX)}px)` }}
      aria-labelledby={sectionId}
    >
      {/* Padding lives inside the scroll container so the card rests clear of the top bar when it fits,
          but clips flush at both edges when it overflows. */}
      <div className="flex flex-col gap-3 md:gap-3.5 py-3.5">
        <SectionHeader as="h2" className={FontStyles.h5} text="Marketed by" id={sectionId} />
        <FirmCard
          imageSlot={
            agentLogoUrl ? (
              <AgentLogoImage
                agentLogoUrl={agentLogoUrl}
                agentName={agentName}
                agentPageUrl={agentPageUrl}
                imgClassName="w-full h-full object-contain"
                linkClassName="relative block w-full h-full"
              />
            ) : undefined
          }
          actionsSlot={
            <>
              <div className="flex flex-col gap-3.5">
                {viewingDescription && <p className={FontStyles["body-md"]}>{viewingDescription}</p>}
                <BookingButton className="p-4" />
                {hrLink && (
                  <ButtonLink
                    href={hrLink}
                    className="p-4"
                    variant="solid"
                    colorVariant="secondary"
                    label="Get home report"
                    renderLeadingIcon={() => <i aria-hidden="true" className="fa-sharp fa-regular fa-file-lines" />}
                  />
                )}
                {scheduleLink && (
                  <ButtonLink
                    href={scheduleLink}
                    className="py-3 px-3.5"
                    variant="outlined"
                    colorVariant="secondary"
                    target="_blank"
                    rel="noopener noreferrer"
                    label="View schedule"
                    onClick={() => TrackEvent({ name: "schedule_clicked", value: 15 })}
                    renderLeadingIcon={() => <i aria-hidden="true" className="fa-sharp fa-regular fa-book-open" />}
                  />
                )}
                {chartered && <CharteredLogo className="mx-auto" />}
              </div>
            </>
          }
        />
      </div>
    </section>
  );
};
